import { render, staticRenderFns } from "./digitalAssets.vue?vue&type=template&id=70eda5da&scoped=true"
import script from "./digitalAssets.vue?vue&type=script&lang=js"
export * from "./digitalAssets.vue?vue&type=script&lang=js"
import style0 from "./digitalAssets.vue?vue&type=style&index=0&id=70eda5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eda5da",
  null
  
)

export default component.exports